
'use strict';
import {Injectable, Inject} from 'ng-metadata/core';

const clone= require('lodash/clone');

@Injectable()
export class DidUMeanService {

    constructor(@Inject('$location') private $location: ng.ILocationService) {
    }

    public getStateParams(didUMean:string, query:string){
        let params= clone(this.$location.search());
        params.facet= null;
        if (!query) {
            query = 'any,contains,'+didUMean;
        }
        if (Array.isArray(query)){
            query = query[0];
        }
        let splittedQuery = query.split(',');
        splittedQuery = splittedQuery.slice(0,3);
        if (splittedQuery.length < 3) {
            splittedQuery[0] = 'any';
            splittedQuery[1] = 'contains';
        }
        splittedQuery[2] = didUMean;
        params.query = splittedQuery.join(',');
        return params;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/didUMean/didUMean.service.ts